import { connect } from 'formik';
import { type FormHTMLAttributes } from 'react';

/** Formik-connected form. */
/**
 * @deprecated Use `Form` from `formik` instead.
 */
const Form = connect<Omit<FormHTMLAttributes<HTMLFormElement>, 'onSubmit' | 'onReset' | 'noValidate'>>(
  ({ formik: { handleReset, handleSubmit }, ...props }) => (
    <form onReset={handleReset} onSubmit={handleSubmit} noValidate {...props} />
  ),
);

Form.displayName = 'Form';

export default Form;
